/* The Epicurean Trader - Add to cart buttons on maker product cards.
   Adds without leaving the page, shows "Added", updates the cart count and opens the cart drawer. */
(function () {
  'use strict';
  if (window.__tetAtc) return;
  window.__tetAtc = true;

  var css = '' +
    '.tetm-card-wrap{display:flex;flex-direction:column;height:100%}' +
    '.tetm-card-wrap>.tetm-card{flex:1 1 auto;height:auto}' +
    '.tetm-atc{margin:12px 0 0}' +
    '.tetm-atc__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:42px;padding:0 12px;border:1.5px solid #00253D;border-radius:2px;background:#00253D;color:#FFFFFF;font-family:Montserrat,"Helvetica Neue",Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;text-decoration:none;cursor:pointer;transition:background-color .2s,color .2s}' +
    '.tetm-atc__btn:hover{background:#0A3654;border-color:#0A3654;color:#FFFFFF}' +
    '.tetm-atc__btn:focus-visible{outline:2px solid #00253D;outline-offset:3px}' +
    '.tetm-atc__btn--ghost{background:#FFFFFF;color:#00253D}' +
    '.tetm-atc__btn--ghost:hover{background:#00253D;color:#FFFFFF}' +
    '.tetm-atc__btn[disabled]{background:#F4F4F3;border-color:#E1E1DF;color:#8A8A8D;cursor:default}' +
    '.tetm-atc__btn.is-added{background:#FFFFFF;color:#00253D}' +
    '.tetm-atc__msg{margin:6px 0 0;font-size:12px;line-height:1.4;color:#B3261E}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function setCount(n) {
    var el = document.getElementById('tn-cart-count');
    if (el) el.textContent = n > 99 ? '99+' : n;
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('tetm-atc')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('.tetm-atc__btn');
    var label = btn ? btn.textContent : '';
    var old = form.querySelector('.tetm-atc__msg');
    if (old) old.remove();
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
        if (btn) { btn.disabled = false; btn.classList.add('is-added'); btn.textContent = 'Added'; }
        setTimeout(function () { if (btn) { btn.classList.remove('is-added'); btn.textContent = label; } }, 2200);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            setCount(cart.item_count || 0);
            document.dispatchEvent(new Event('tet:cart:refresh'));
            document.dispatchEvent(new Event('tet:cart:open'));
          });
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        var m = document.createElement('p');
        m.className = 'tetm-atc__msg';
        m.setAttribute('role', 'alert');
        m.textContent = err && err.message ? err.message : 'Could not add to cart';
        form.appendChild(m);
      });
  }, true);
})();
